import React from "react";
import "./App.css";
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import About from "./components/About";
import BookSection from "./components/BookSection";
import Events from "./components/Events";
import Experience from "./components/Experience";
import Projects from "./components/Projects";
import Services from "./components/Services";
import Contact from "./components/Contact";
import Footer from "./components/Footer";
import { Toaster } from "./components/ui/toaster";

function App() {
  return (
    <div className="App min-h-screen">
      <Navbar />
      <Hero />
      <About />
      <BookSection />
      <Events />
      <Experience />
      <Projects />
      <Services />
      <Contact />
      <Footer />
      <Toaster />
    </div>
  );
}

export default App;
